module.exports = __webpack_public_path__ + "/content/skins/tfs-hdemo/fav/android-chrome-192x192.png";